import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  CustomsIcon,

  AutomatedCustomTracker,
  CreateShipmentUsingSBBE,
  CustomAnalyticsDashboard,
} from '../../assets';

const CustomsPage = () => {
  const productData = {
    productName: 'Customs',
    tagline: 'Simplified Customs Clearance and Compliance',
    metaDescription: 'Customs clearance module for Indian freight forwarders and CHAs: manage Shipping Bills & Bills of Entry, track filing status in real time, and get customs analytics. ICEGATE direct filing coming soon.',
    description: 'Simplify customs compliance with dedicated Shipping Bill and Bill of Entry management, real-time filing status tracking, and a comprehensive customs analytics dashboard.',
    icon: CustomsIcon,
    features: [
      {
        title: 'Automated Status Tracking',
        description: 'Real-time automated tracking for all your customs filings.',
        image: AutomatedCustomTracker,
      },
      {
        title: 'Seamless Shipment Creation',
        description: 'Create shipments instantly using SB/BE files.',
        image: CreateShipmentUsingSBBE,
      },
      {
        title: 'Comprehensive Analytics',
        description: 'Gain insights into your customs operations with a dedicated dashboard.',
        image: CustomAnalyticsDashboard,
      },
    ],
    faqs: [
      {
        question: 'Does Shipmnts send Daily Shipment Reports (DSR) to clients automatically?',
        answer: 'Yes. Shipmnts auto-generates and sends Daily Shipment Reports to your clients: covering active shipment status, milestones, and pending actions. DSRs are sent automatically so your team does not need to prepare or email them manually.',
      },
      {
        question: 'Is Shipmnts suitable for Customs House Agents (CHAs)?',
        answer: 'Yes. Shipmnts is built for CHAs and freight forwarders managing Indian customs operations. It supports multi-client operations, SB/BE document management, real-time customs status tracking, automated DSR dispatch, and a dedicated customs analytics dashboard in a single workspace.',
      },
      {
        question: 'Can I create a shipment from an SB or BE file in Shipmnts?',
        answer: 'Yes. Shipmnts can parse Shipping Bill and Bill of Entry files to auto-populate shipment details, eliminating manual data entry and reducing errors.',
      },
      {
        question: 'Does Shipmnts support ICEGATE integration?',
        answer: 'ICEGATE direct filing (Shipping Bill and Bill of Entry submission) is actively in development and coming soon. Currently, Shipmnts supports automated customs status tracking via ICEGATE, SB/BE document management, and a comprehensive customs analytics dashboard.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default CustomsPage;
